import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthApi from '../../services/Auth';

import logo from '../../assets/images/Kronos.svg';
import './Login.css';

const LoginConfirmEmail = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const tokenFromUrl     = searchParams.get('token') || '';

    const [loading, setLoading] = useState(false);
    const [error, setError]     = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        if (!tokenFromUrl) {
            return;
        }
        setLoading(true);
        setError('');
        AuthApi.confirmEmailChange(tokenFromUrl)
            .then((message) => {
                setSuccess(typeof message === 'string' ? message : t('login.email_change_confirmed'));
            })
            .catch((err) => {
                setError(err.message || t('login.generic_error'));
            })
            .finally(() => setLoading(false));
    }, [tokenFromUrl, t]);

    if (!tokenFromUrl) {
        return (
            <div className="LoginForm appear text-start">
                <img className="logo" src={logo} alt="logo" />
                <div className="alert alert-warning mt-3" role="alert">
                    {t('login.email_change_missing_token')}
                </div>
                <p>
                    <Link to="/login">{t('login.back_to_login')}</Link>
                </p>
            </div>
        );
    }

    return (
        <div className="LoginForm appear text-start">
            <img className="logo" src={logo} alt="logo" />
            <h2 className="h4 mb-3">{t('login.email_change_title')}</h2>
            {loading && (
                <p>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true" />&nbsp;
                    {t('login.email_change_confirming')}
                </p>
            )}
            {success && (
                <div className="alert alert-success" role="alert">
                    {success}
                </div>
            )}
            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}
            <p className="mt-3">
                <Link to="/login">{t('login.back_to_login')}</Link>
            </p>
        </div>
    );
};

export default LoginConfirmEmail;
